import { jsx as _jsx } from "react/jsx-runtime";
import { useEditorReadOnly, useEditorRef } from '@udecode/plate/react';
import { forwardRef } from 'react';
import { useMarkdownProps } from './context';
import { ImageElement } from './ImageElement';
import { isRichUXEmbedding } from './utils';
export const ImageAndEmbeddingsWrapperElement = /*#__PURE__*/ forwardRef((props, ref)=>{
    const editor = useEditorRef();
    const readOnly = useEditorReadOnly();
    const { element } = props;
    const { url } = element;
    const { embeddingElement: RichUXEmbeddingElement } = useMarkdownProps();
    if (typeof url === 'string' && isRichUXEmbedding(url) && RichUXEmbeddingElement) {
        return /*#__PURE__*/ _jsx(RichUXEmbeddingElement, {
            ref: ref,
            ...props,
            editor: editor,
            readOnly: readOnly
        });
    }
    return /*#__PURE__*/ _jsx(ImageElement, {
        ref: ref,
        ...props
    });
});
